import { Typography } from "antd";
import { useWidgetData } from "../Contexts/dashboardHooks";
import { GROUPBY_OPTIONS } from "../AddWidgetModal/constants";
import { resolveDateRange } from "../Utils/resolveDateRange";
import { formatSeriesLabel } from "../Processing/seriesLabel";
import type { TableComponentSpec } from "../Processing/types";

const { Text } = Typography;

export function TableInfo({ id }: { id: string }) {
  const data = useWidgetData(id);
  if (!data || data.type !== "table") return null;
  const spec = data.spec as TableComponentSpec;
  if (!spec.series.length) return null;

  const misc = spec.table_builder_misc;
  const groupBy = GROUPBY_OPTIONS.find((o) => o.value === misc?.groupBy)?.label
    ?? misc?.groupBy ?? "Day";

  const dateLabel = resolveDateRange(misc);

  const names = misc?.selectedSubjectNames ?? [];
  const MAX_ITEMS = 20;
  const subjectLabel = names.length === 0
    ? "Full Team"
    : names.length <= MAX_ITEMS
      ? names.join(", ")
      : `${names.slice(0, MAX_ITEMS).join(", ")} (+${names.length - MAX_ITEMS} more)`;

  return (
    <div style={{ maxWidth: 360, fontSize: 12, lineHeight: 1.6 }}>
      {spec.series.map((ser) => {
        const label = ser.displayNameOverride?.trim()
          ? ser.displayNameOverride.trim()
          : formatSeriesLabel(ser.displayName, ser.metricAgg, ser.metricIdentifierType);
        const aggLabel = { avg: "Average", sum: "Sum", best: "Best" }[ser.metricAgg] ?? ser.metricAgg;
        return (
          <div key={ser.queryId} style={{ marginBottom: 4 }}>
            <Text strong style={{ fontSize: 12 }}>{label}</Text>
            <div style={{ paddingLeft: 4, color: "rgba(0,0,0,0.65)" }}>
              <div>Aggregate: {aggLabel}</div>
            </div>
          </div>
        );
      })}
      <div style={{ paddingLeft: 4, color: "rgba(0,0,0,0.65)", marginTop: 4 }}>
        <div>Dates: {dateLabel}</div>
        <div>Players: {subjectLabel}</div>
        <div>Grouped By: {groupBy}</div>
      </div>
    </div>
  );
}
